/**
 * Pulls a human-readable message out of an RTK Query error.
 *
 * The API sends failures as { status: "failed", error: { message } }, while
 * Laravel validation (422) sends { message, errors }. Always returns a string,
 * so it's safe to render or toast — never the error object itself.
 */
export const getApiErrorMessage = (err: any, fallback: string): string => {
  const data = err?.data;
  const firstFieldError = data?.errors && typeof data.errors === "object"
    ? Object.values(data.errors).flat()[0]
    : undefined;

  const candidates = [data?.error?.message, data?.message, firstFieldError, data?.error];
  const message = candidates.find((m) => typeof m === "string" && m.trim());

  return (message as string | undefined) ?? fallback;
};
